






















import { defineComponent, getCurrentInstance, ref, watch } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import AppStorage from "@/lib/appStorage";
import { isWebApp, iosVersion, getNotificationsPermissions } from "@/lib/browserUtils";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

const PUSH_NOTIFICATIONS_KEY = "PUSH_NOTIFICATIONS_POPUP_SHOWN";

export default defineComponent({
  name: "ModalPushNotificationsHelper",
  components: { BaseButton, BaseConfirm },
  setup() {
    const vm = getCurrentInstance();
    const show = ref(false);

    const onConfirm = () => {
      AppStorage.setBoolean(PUSH_NOTIFICATIONS_KEY, true);
      show.value = false;
      vm?.$router.push({ name: "pushNotificationsSettings" });
    };

    const onClose = () => {
      AppStorage.setBoolean(PUSH_NOTIFICATIONS_KEY, true);
      show.value = false;
    };
    const { authUser } = useAuthUser();
    const tryToShow = () => {
      if (!config.webPushNotificationsPublicKey) {
        return;
      }
      const isPopupSeen = AppStorage.getBoolean(PUSH_NOTIFICATIONS_KEY, false);
      const isNotificationDisabledCheck = getNotificationsPermissions() !== "granted";
      const version = iosVersion().version;
      const subVersion = parseInt(iosVersion().info.split(".")[1] ?? "0");

      if (
        authUser.value &&
        !isPopupSeen &&
        isNotificationDisabledCheck &&
        (!isWebApp || version < 16 || subVersion < 5)
      ) {
        show.value = true;
      }
    };
    tryToShow();
    const unwatch = watch(authUser, (newValue, prevValue) => {
      if (!prevValue && newValue) {
        tryToShow();
        unwatch();
      }
    });

    return { show, onClose, onConfirm };
  },
});
